import { loaderModal } from "../AlertLoaderService";
import { doPost as omsDoPost, doPostGuest as omsGuestDoPost } from "../api/OMSAPI";

import { extendLocationData } from "../ExtendedDataUtils";

export const getCurrentLocation = (isUserLoggedIn, setBlockLocationModalPopup) => {
    loaderModal.setLoader(true)
    return new Promise((resolve) => {
        navigator.geolocation.getCurrentPosition(function (position) {
            let coordinates = {
                latitude: position.coords.latitude,
                longitude: position.coords.longitude
            }
            if (isUserLoggedIn) {
                omsDoPost('gplaces/get_location_details',
                    { latLng: coordinates }).then(
                        (response: any) => {
                            var currentLocation = extendLocationData(response,
                                { isSavedLocation: false })
                            loaderModal.setLoader(false)
                            resolve(currentLocation)
                        }, (err: any) => { console.log("API is failed with error " + err) }
                    )
            } else {
                omsGuestDoPost('get_location_details',
                    { latLng: coordinates }).then(
                        (response: any) => {
                            var currentLocation = extendLocationData(response,
                                { isSavedLocation: false })
                            loaderModal.setLoader(false)
                            resolve(currentLocation)
                        }, (err: any) => { console.log("API is failed with error " + err) }
                    )
            }
        }, function (error) {
            setBlockLocationModalPopup()
            loaderModal.setLoader(false)
            resolve(null)
        }
        );
    });
}